import { http } from 'utils'
import { config } from 'config'

import BaseStore from './BaseStore'

let state

export class Otp extends BaseStore {
  constructor() {
    super()
    this.observable({
      selected: '',
    })
    state = this
  }

  async validateMobileNumber({ mobile } = {}) {
    const url = `${config.api}/customer-profile/customers/validate`
    const json = { mobile }
    const res = await http.post(url, { json })

    return res.body
  }

  async requestOtp({ mobile } = {}) {
    const url = `${config.api}/mobile-auth/public/otp`
    const json = { mobile }
    const res = await http.post(url, { json })

    return res.body
  }

  async requestOtpRequest({ mobile, token } = {}) {
    const url = `${config.api}/mobile-auth/public/otp/request`
    const json = { mobile, token }
    const res = await http.post(url, { json })

    return res.body
  }

  async verifyOtp({ mobile, otp, refCode } = {}) {
    const url = `${config.api}/mobile-auth/public/otp/verify`
    const json = { mobile, otp, refCode }
    const res = await http.post(url, { json })

    return res.body
  }

  async loginPinCode({
    token,
    pinCode,
    redirectUri,
    clientId,
    state,
    codeChallenge,
  } = {}) {
    const url = `${config.api}/mobile-auth/public/auth`
    const json = {
      token: token,
      pinCode,
      grantType: 'pin_code',
      tokenType: 'otpToken',
      redirectUri,
      clientId,
      state,
      codeChallenge,
    }

    const res = await http.post(url, { json })
    return res
  }

  async validateEmail({ email } = {}) {
    const url = `${config.api}/customer-profile/customers/validate/email`
    const json = { email }
    const res = await http.post(url, { json })

    return res.body
  }

  async requestEmailOtpRequest({ email, token } = {}) {
    const url = `${config.api}/mobile-auth/public/otp/email/request`
    const json = { email, token }
    const res = await http.post(url, { json })

    return res.body
  }

  async verifyEmailOtp({ email, otp, refCode } = {}) {
    const url = `${config.api}/mobile-auth/public/otp/email/verify`
    const json = { email, otp, refCode }
    const res = await http.post(url, { json })

    return res.body
  }
}

export default new Otp()
